// extracted by mini-css-extract-plugin
module.exports = {"CopyTextInput":"CopyTextInput_CopyTextInput__gtw8w","Input":"CopyTextInput_Input__aPFBi","Tooltip":"CopyTextInput_Tooltip__3KMYc","Enabled":"CopyTextInput_Enabled__2d1oz"};